import { Box, Button, Stack, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
// import { useNavigate, } from "react-router-dom";

export default function EntitiesForm({
  setOpenModel2,
  fetchData,
  currentPage,
}) {
  // const navigate = useNavigate();
  const schema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange", // important: enables real-time validation
  });

  const title = watch("title");
  const description = watch("description");

  const onSubmit = async (data) => {
    const payload = {
      title: data?.title,
      description: data?.description,
      img_url: "Na",
    };

    try {
      const response = await axios.post(
        `https://api.medstown.com/offer/entities`,
        payload
      );
      if (response?.status === 201) {
        toast.success(`${response?.data?.message}`, {
          position: "top-right",
          theme: "dark",
          autoClose: 1000,
          onClose: () => {
            setOpenModel2(false); // ✅ Close modal after toast
          },
        });
      }
      fetchData(currentPage);
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!", {
        position: "top-right",
        theme: "dark",
      });
    }
  };

  return (
    <Box>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          sx={{
            width: "99%",
            margin: "auto",
            "& .MuiInputLabel-asterisk": { color: "red" },
            marginTop: "8px",
            marginBottom: "8px",
          }}
          label="Title"
          error={!!errors.title}
          helperText={errors.title ? errors.title.message : ""}
          {...register("title")}
        />
        <TextField
          multiline
          rows={4}
          sx={{
            width: "99%",
            margin: "auto",
            "& .MuiInputLabel-asterisk": { color: "red" },
            marginTop: "8px",
          }}
          label="Description"
          error={!!errors.description}
          helperText={errors.description ? errors.description.message : ""}
          {...register("description")}
        />
        <Stack alignItems="center" sx={{ marginTop: 3, marginBottom: 3 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={!isValid || !title || !description}
          >
            submit
          </Button>
        </Stack>
      </form>
    </Box>
  );
}
